import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue';

import type { ObjectType } from '@/@types/graphql-types';
import type { FastOfferFragment } from '@/components/buybox/graphql/fragments/Offer.fragment';
import type { OfferVisibilityChangedPayload } from '@/helpers/composables/useOfferImpressionTracking';

import { useLanguageStore } from '@/helpers/composables/useStores';

import BuyBoxOffer from '@/components/buybox/BuyBoxOffer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxFastOffer',
  props: {
    offer: null,
    objectType: null
  },
  emits: ["clickOut", "visibilityChanged"],
  setup(__props: any) {

const props = __props as {
	offer: FastOfferFragment;
	objectType: ObjectType;
}

const { language, country } = useLanguageStore();
const isMounted = ref(false);





// Live status
const liveStatus = computed(() => {
	const now = new Date();
	return new Date(props.offer.availableFromTime) <= now && now < new Date(props.offer.availableToTime);
});

const dateOptions = {
	day: 'numeric',
	month: 'short',
} as const;

const timeOptions = {
	hour: 'numeric',
	minute: 'numeric',
} as const;

const USTimeZone = 'America/New_York';

onMounted(() => {
	isMounted.value = true;
});

const formattedDate = computed(() => {
	const options = isMounted.value ? dateOptions : { ...dateOptions, timeZone: USTimeZone };
	return new Intl.DateTimeFormat(`${language.value}-${country.value}`, options).format(
		new Date(props.offer.availableFromTime)
	);
});

const formattedTime = computed(() => {
	const options: Intl.DateTimeFormatOptions = isMounted.value
		? timeOptions
		: { ...timeOptions, timeZoneName: 'short', timeZone: USTimeZone };
	return new Intl.DateTimeFormat(`${language.value}-${country.value}`, options).format(
		new Date(props.offer.availableFromTime)
	);
});

return { __sfc: true,language, country, isMounted, props, liveStatus, dateOptions, timeOptions, USTimeZone, formattedDate, formattedTime, BuyBoxOffer }
}

})